/*@ngInject*/
const ModalController = function ($rootScope, $scope, options, coreConstant, functionActionUtil) {

    $scope.viewModel = {
        showCancelButton: !_.isUndefined(options.cancelButtonLabel),
        showConfirmActionButton: !_.isUndefined(options.confirmActionButtonLabel),
        confirmActionButtonLabel: options.confirmActionButtonLabel,
        summary: options.summary,
        cancelButtonLabel: options.cancelButtonLabel,
        title: options.title,
        showCustomButton: !_.isUndefined(options.customButtonType),
        customButtons: options.customButtons,
        showAlternateButton: !_.isUndefined(options.alternateButtonLabel),
        alternateButtonLabel: options.alternateButtonLabel,
        submission: options.submission,
        contextParameters : options.contextParameters
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.isPrimaryButton = function (alert) {
        let parameterObject = functionActionUtil.getParameterAsObject(alert.parameters);
        if(parameterObject.action === 'noOpen') {
            return false;
        }
        return true;
    };

    $scope.onCustomButtonClick = function (alert) {
        let parameterObject = functionActionUtil.getParameterAsObject(alert.parameters);
        if(parameterObject.action === 'noOpen') {
            $scope.$close();
        } else {
            functionActionUtil.handleAction(alert, $scope.viewModel.submission, options.customButtonType, alert.name, options.contextParameters);
            $scope.$close('confirm');
        }
    };

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('modalController', ModalController);
